import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";
import "./Side.css";
const LeftSide = () => {
  return (
    <div id="left" className="d-flex flex-column" data-aos="fade-down">
      <div className="d-flex flex-column gap-5 text-green">
        <a
          href="https://www.linkedin.com/in/md-shoyeb-49645020a/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaLinkedinIn size={28} />
        </a>
        <a
          href="http://wa.me/919871904481"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          {" "}
          <FaWhatsapp size={28} />
        </a>

        <a
          href="http://github.com/shoyebmd424"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaGithub size={28} />
        </a>
        <a
          href="http://facebook.com/shoyeb"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaFacebookF size={28} />
        </a>
        <a
          href="tel:+919871904481"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green"
        >
          <FaPhone size={28} />
        </a>
      </div>
      <div className="left-empty"></div>
    </div>
  );
};

export default LeftSide;
